/* eslint-disable */
"use strict";

var config, service, ottici;
(async () => {
  if (!config || !service) {
    await getConfigFile();
  }
})();

async function getConfigFile() {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.VUE_APP_MOL_API_GATEWAY
  ottici = config.VUE_APP_MOL_S_OTTICI
}

exports.generaXML = async function(impostazioni, documenti) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    impostazioni,
    documenti,
  };
  const response = await fetch(`${service}/${ottici}/xml/genera`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
};

exports.generaInviaXML = async function(impostazioni, documenti) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    impostazioni,
    documenti,
  };
  const response = await fetch(`${service}/${ottici}/xml/genera/invia`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
};

exports.esitoErroriXML = async function(impostazioni, protocollo) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    impostazioni,
    protocollo,
  };
  const response = await fetch(`${service}/${ottici}/xml/esito/errori`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
};

exports.esitoInvioXML = async function(impostazioni, protocollo) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    impostazioni,
    protocollo,
  };
  const response = await fetch(`${service}/${ottici}/xml/esito/invio`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
};

exports.ricevutaPdfXML = async function(impostazioni, protocollo) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    impostazioni,
    protocollo,
  };
  const response = await fetch(`${service}/${ottici}/xml/ricevuta/pdf`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
};
